(function() {
    const path = window.location.pathname;
    const hotelFormID = limeFormsData.formId || '';

    const pageTitleElement = document.querySelector('h1');
    const trimmedTitle = pageTitleElement
        ? pageTitleElement.textContent.trim()
        : null;

    const foodCsv = localStorage.getItem('svm:campaign:selected:foodType') || '';
    const offerCsv = localStorage.getItem('svm:campaign:selected:offerType') || '';

    const split = s => s
        ? s.split(', ').map(x => x.trim()).filter(Boolean)
        : [];

    const foodArr = split(foodCsv);
    const offerArr = split(offerCsv);

    const cleanPath = path.replace(/\/$/, '');
    const isJulbordOverview = cleanPath === '/kampanj/julbord' ||
        cleanPath === '/kampanjer/julbord';

    const page = path.split('/').filter(Boolean);
    const pageLast = page[page.length - 1];
    const locationFromUrl = pageLast ? pageLast.replace(/-/g, ' ') : null;

    function populateForm(selector) {
        const element = document.querySelector(selector);
        if (!element) return;

        try {
            window.waitForDeferred(
                'lime-forms',
                function() {
                    return window.limeForms != null;
                },
                function() {
                    const formsApi = window.limeForms.getApi(hotelFormID);

                    const julbordDateFrom = '2026-11-09';
                    const julbordDateEnd  = '2026-12-25';

                    formsApi.onReady(function() {
                        if (isJulbordOverview) {
                            formsApi.setFieldValue(
                                'custom-datepicker-startdate',
                                julbordDateFrom,
                            );
                            formsApi.setFieldValue(
                                'custom-datepicker-enddate',
                                julbordDateEnd,
                            );
                        } else if (window.campaigns && window.campaigns.dateFrom) {
                            formsApi.setFieldValue(
                                'custom-datepicker-startdate',
                                window.campaigns.dateFrom,
                            );
                            formsApi.setFieldValue(
                                'custom-datepicker-enddate',
                                window.campaigns.dateEnd,
                            );
                        }

                        if (foodArr.length) {
                            formsApi.setFieldValue('other_info_meals', foodArr);
                        }

                        if (offerArr.length) {
                            formsApi.setFieldValue('requests_type', offerArr);
                        }

                        if (!isJulbordOverview && locationFromUrl != null) {
                            const locationValue = trimmedTitle || locationFromUrl;
                            formsApi.setFieldValue('other_info_location', locationValue);

                            // Fallback: set directly on DOM for fields on other form steps
                            const input = document.querySelector('input[name="other_info_location"]');
                            if (input) {
                                const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
                                setter.call(input, locationValue);
                                input.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                        }
                    });
                },
            );
        } catch (ex) {
            console.error(ex);
        }
    }

    // Run for both placements
    populateForm('.campaign-form');
    populateForm('.campaign-widget');

    // Also populate when flyout opens (lime-form initializes lazily)
    document.body.addEventListener('svm/flyout', function(event) {
        if (event.flyout === 'booking-campaign') {
            populateForm('.campaign-form');
            populateForm('.campaign-widget');
        }
    });

})();

//# sourceMappingURL=lime-forms-campaign.js.map
